import { Box } from '@mui/material';

export const BrowserGrid = ({
  children,
  gap = '24px',
  columns = 2,
}: {
  children: React.ReactNode;
  gap?: string;
  columns?: number;
}) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        gap,
      }}
    >
      {children}
    </Box>
  );
};
